/**
 * Wealthica2 identifier utilities
 * - Resolve a stable identifier for consolidating rotating OAuth institution IDs
 * - Detect demo provider connections
 * - Normalize IDs for cache keys
 */

export function isDemoProvider(
  providerName?: string,
  institutionIdentifier?: string | null,
  institutionId?: string
): boolean {
  const p = (providerName || '').toLowerCase();
  const id = (institutionId || '').toLowerCase();
  const ident = (institutionIdentifier || '').toLowerCase();
  return (
    p === 'demo' ||
    ident === 'demo' ||
    id === 'demo' ||
    id.includes('demo')
  );
}

/**
 * Returns a provider-stable identifier that should remain consistent across
 * rotating OAuth institution IDs.
 *
 * For demo provider, returns the constant 'demo'.
 * For normal providers, prefers the explicit institutionIdentifier if present,
 * otherwise falls back to institutionId.
 */
export function resolveStableIdentifier(params: {
  providerName?: string;
  institutionIdentifier?: string | null;
  institutionId: string;
}): string {
  const { providerName, institutionIdentifier, institutionId } = params;
  if (isDemoProvider(providerName, institutionIdentifier, institutionId)) {
    return 'demo';
  }
  return institutionIdentifier || institutionId;
}

/**
 * Normalize institution ID for cache keys (positions/accounts).
 * - For demo connections, use a fixed key to avoid cache proliferation.
 */
export function normalizeInstitutionIdForCache(
  institutionId: string,
  providerName?: string,
  institutionIdentifier?: string | null
): string {
  if (isDemoProvider(providerName, institutionIdentifier, institutionId)) {
    return 'wealthica-demo';
  }
  return institutionId;
}
